import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";

function CheckBox({ value, handleChange, name, title }) {
  return (
    <FormControlLabel
      style={{ marginTop: "16px" }}
      control={
        <Checkbox
          color="primary"
          checked={value}
          onChange={handleChange}
          name={name}
        />
      }
      label={title}
    />
  );
}

export default CheckBox;
